import React, { Component } from 'react';
import { Container} from 'semantic-ui-react';
import { PtSelect, PtDateInput } from '../../../grit-utilities';
import ScrollArea from 'react-scrollbar';
import DropdownLib from '../../../DropdownLib';

export default class Condition extends Component {

    constructor(props) {
        super(props);
        const { minorModel } = this.props;
        this.state = minorModel.condition;
    }

    render() {
        const { conditionOptions } = DropdownLib.getDropdowns().MS_Condition;
        return (
            <Container>
                <ScrollArea
                    speed={1}
                    className={!window.mobileAndTabletcheck() ? "area_desktop" : "area_mobile"}
                    contentClassName="content"
                    smoothScrolling={true}>

                    <PtSelect label="Erosion" options={conditionOptions} disabled={this.props.disabled}
                        name="erosion" defaultVal={this.state.erosion} onChange={this.onChangeDropdown} />
                    <PtSelect label="Roadway" options={conditionOptions} disabled={this.props.disabled}
                        name="roadway" defaultVal={this.state.roadway} onChange={this.onChangeDropdown}/>
                    <PtSelect label="Waterway Flow" options={conditionOptions} disabled={this.props.disabled}
                        name="waterwayFlow" defaultVal={this.state.waterwayFlow} onChange={this.onChangeDropdown}/>
                    <PtSelect label="Overall Structure" options={conditionOptions} disabled={this.props.disabled}
                        name="overallStructure" defaultVal={this.state.overallStructure} onChange={this.onChangeDropdown}/>

                    <PtDateInput label="Rating Date" name="ratingDate" disabled={this.props.disabled}
                        value={this.state.ratingDate}
                        onChange={(date) => { this.onChangeDate(date, "ratingDate"); }} minDate={new Date(1900, 5, 5)} maxDate={new Date(2030, 5, 5)} />
                </ScrollArea>
            </Container>
        );
    }


    onChangeDropdown = (e) => {
        const { target } = e;
        const {name, value} = target;
        this.props.triggerNeedSave();
        // eslint-disable-next-line
        this.setState({ [name]: parseInt(value) });
    }

    onChangeDate = (date, name) => {
        if (date != null) {
            this.props.triggerNeedSave();
            this.setState({ [name]: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` });
        } else{
            this.props.triggerNeedSave();
            this.setState({ [name]: null });
        }
    }

    componentDidUpdate()
    {
        this.props.minorModel.condition = this.state;
    }
}


// WEBPACK FOOTER //
// ./src/layers/tabs/minor-structs/condition.js